import {httpGet,httpPut,httpDelete,httpPost} from '../../../../util/request.js';
import appConfig from '../../../../config';

export default class BackendSendApi{

    static QUERY_BACKENDSEND_API_URL = appConfig.gatewayUrl+appConfig.smMarketManageServicePath+"/crm/printcoupon/backendSends";
    static SAVE_BACKENDSEND_API_URL = appConfig.gatewayUrl+appConfig.smMarketManageServicePath+"/crm/printcoupon/backendSend";
    static GET_BACKENDSEND_API_URL = appConfig.gatewayUrl+appConfig.smMarketManageServicePath+"/crm/printcoupon/backendSend";
    static BACKEND_SEND_PRINT_API_URL = appConfig.gatewayUrl+appConfig.smMarketManageServicePath+"/crm/printcoupon/backendsend/print";

    //static QUERY_GIVE_COUPON_API_URL = appConfig.gatewayUrl+appConfig.smMarketManageServicePath+"/printcoupon/givecoupons";
	
		static queryBackendSend(params){
			return httpGet(BackendSendApi.QUERY_BACKENDSEND_API_URL,params);
    }

    static getBackendSend(params){
			return httpGet(BackendSendApi.GET_BACKENDSEND_API_URL,params);
    }

    static saveBackendSend(params){
			return httpPost(BackendSendApi.SAVE_BACKENDSEND_API_URL,params);
    }

    static backendSendPrint(params){
			return httpPost(BackendSendApi.BACKEND_SEND_PRINT_API_URL,params);
    }
	
}